"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var final_form_1 = require("final-form");
var react_final_form_1 = require("react-final-form");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var Main_1 = __importDefault(require("components/Layout/Main"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var TextField_1 = __importDefault(require("shared/components/Form/TextField"));
var Link_1 = __importDefault(require("shared/components/Link"));
var Text_1 = __importDefault(require("shared/components/Text"));
var firebaseConf_1 = require("utils/firebaseConf");
var logging_1 = require("utils/logging");
var AuthIntroSection_1 = __importDefault(require("../AuthIntroSection"));
var hooks_1 = require("../hooks");
var LayoutCenter_1 = __importDefault(require("../styles/LayoutCenter"));
var LoadingIcon_1 = __importDefault(require("../styles/LoadingIcon"));
var StyledGrid_1 = __importDefault(require("../styles/StyledGrid"));
var CustomTokenTest = function () {
    (0, hooks_1.useRedirectIfAuth)();
    var onSubmit = function (_a) {
        var token = _a.token;
        return __awaiter(void 0, void 0, void 0, function () {
            var e_1;
            var _b, _c, _d, _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _g.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, firebaseConf_1.auth.signInWithCustomToken(token)];
                    case 1:
                        _g.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _g.sent();
                        (0, logging_1.logInfo)('e.code', e_1.code);
                        (0, logging_1.logInfo)('e', e_1);
                        if (e_1.code.split('/')[1] === 'user-not-found') {
                            return [2 /*return*/, (_b = {}, _b[final_form_1.FORM_ERROR] = 'Unregistered Email!', _b)];
                        }
                        if (e_1.code.split('/')[1] === 'too-many-requests') {
                            return [2 /*return*/, (_c = {}, _c[final_form_1.FORM_ERROR] = 'Too Many Attempts, Try Again Later!', _c)];
                        }
                        if (e_1.code.split('/')[1] === 'invalid-custom-token') {
                            return [2 /*return*/, (_d = {}, _d[final_form_1.FORM_ERROR] = 'Invalid custom token', _d)];
                        }
                        if (e_1.code.includes('user-disabled')) {
                            return [2 /*return*/, (_e = {}, _e[final_form_1.FORM_ERROR] = 'Your account is disabled. Please contact an admin to reactivate', _e)];
                        }
                        return [2 /*return*/, (_f = {}, _f[final_form_1.FORM_ERROR] = 'Invalid email or password!', _f)];
                    case 3: return [2 /*return*/, null];
                }
            });
        });
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Hudled Login", description: "Hudled Login" }), (0, jsx_runtime_1.jsx)(Main_1.default, { children: (0, jsx_runtime_1.jsxs)(LayoutCenter_1.default, { children: [(0, jsx_runtime_1.jsxs)(StyledGrid_1.default, __assign({ container: true, spacing: 2, justifyContent: "center" }, { children: [(0, jsx_runtime_1.jsx)(AuthIntroSection_1.default, { welcomeMsg: "Login to access your dashboard" }), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, md: 4 }, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Form, __assign({ onSubmit: onSubmit }, { children: function (_a) {
                                            var handleSubmit = _a.handleSubmit, submitting = _a.submitting, submitError = _a.submitError;
                                            return ((0, jsx_runtime_1.jsxs)("form", __assign({ onSubmit: handleSubmit }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 2 }, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "token", color: "secondary", disabled: submitting, component: TextField_1.default, label: "Token", fullWidth: true }) })), submitError && (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 1 }, { children: (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 2, color: "error", align: "center" }, { children: submitError })) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 2 }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ color: "secondary", onClick: handleSubmit, type: "submit", disabled: submitting }, { children: submitting
                                                                ? (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", alignItems: "center" }, { children: ["Logging in ", (0, jsx_runtime_1.jsx)(LoadingIcon_1.default, { size: "2x" })] }))
                                                                : 'Log in' })) }))] })));
                                        } })) }))] })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 4 }, { children: (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 2 }, { children: ["New to Hudled? ", (0, jsx_runtime_1.jsx)(Link_1.default, __assign({ to: "/signup" }, { children: "Sign up" }))] })) }))] }) })] }));
};
exports.default = CustomTokenTest;
